export default {};
throw new Error(`Could not resolve "postprocessing" imported by "@appletosolutions/reactbits". Is it installed?`)